document.addEventListener("DOMContentLoaded", function () {
  const headerClientHeight = document.querySelector("header").clientHeight;
  document.documentElement.style.setProperty(
    "--header-group-height",
    `${headerClientHeight}px`,
  );
  const anchors = document.querySelector("#anchors");
  anchors &&
    document.documentElement.style.setProperty(
      "--anchors-height",
      `${anchors.clientHeight}px`,
    );
  const mobileMenuContainer = document.querySelector("#mobile-menu-container");
  mobileMenuContainer &&
    mobileMenuContainer.addEventListener("toggle", function (event) {
      if (event.target.open) {
        freezeBody(true);
      } else {
        [
          ...document.querySelectorAll("#mobile-menu-container details"),
        ].forEach((detail) => {
          detail.removeAttribute("open");
        });
        freezeBody(false);
      }
    });
});

function freezeBody(condition) {
  if (typeof window != "undefined" && window.document) {
    if (condition == true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }
}

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

function isMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  ) {
    return true;
  } else {
    return false;
  }
}

function loader(label) {
  const parser = new DOMParser();
  return parser.parseFromString(
    `
  <div class="grid place-items-center w-full h-full col-span-full">
    <div class="flex items-center gap-1.5">
      <svg
        class="animate-spin size-4 text-teal"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      ${label ? "<p>Loading...</p>" : ""}
    </div>
  </div>
`,
    "text/html",
  ).body.firstChild.outerHTML;
}

const fetchOptions = {
  method: "POST",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
};

const filterBtn = document.querySelector("button[data-action='toggle-filters'");
if (filterBtn != undefined || filterBtn != null) {
  isMobile() &&
    filterBtn.addEventListener("click", function () {
      document
        .getElementsByTagName("collection-filters")[0]
        .setAttribute("data-active", "");
      freezeBody(true);
    });
}

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  // Check if any part of the element is in the viewport
  const inViewport =
    rect.top < windowHeight &&
    rect.bottom > 0 &&
    rect.left < windowWidth &&
    rect.right > 0;

  return inViewport;
}



$('#video-poster').click(function(){
$(this).css({"display": "none", "opacity": "0"});
$('#video-click-main').get(0).play(); 
});

$('#video-click-main').on('ended',function(){
$("#video-poster").css({"display": "block", "opacity": "1"});
});


// $(".open_popup").click(function () {
// $(this).parent(".popup_main").children(".popup_body").addClass("popup_body_show");
// });
// $(".popup_close").click(function () {
// $(".popup_body").removeClass("popup_body_show");
// });
// $(".popup_back").click(function () {
// $(".popup_body").removeClass("popup_body_show");
// });


const mainGrid = document.querySelector('[js-hb-main-grid]');
if (mainGrid) {
  const productDots = document.querySelectorAll('[js-hb-dot]');
  const productInfo = document.querySelectorAll('[js-hb-product-info]');
  const closePopup = document.querySelectorAll('[js-close-popup]');

  let currentOpenPopup = null;

  productDots.forEach((dot, index) => {
    dot.addEventListener('click', function () {
      const parentInfo = this.nextElementSibling;

      if (parentInfo !== currentOpenPopup) {
        // if (currentOpenPopup) {
        //   currentOpenPopup.classList.remove('popup_body_show');
        // }

        parentInfo.classList.add('popup_body_show');
        currentOpenPopup = parentInfo;
      }
    });
  });

  closePopup.forEach(button => {
    button.addEventListener('click', function () {
      const popupToClose = this.closest('[js-hb-product-info]');
      if (popupToClose) {
        popupToClose.classList.remove('popup_body_show');
        currentOpenPopup = null; // Reset the open popup tracker
      }
    });
  });

  // Prevent closing the popup when clicking anywhere outside the popup on desktop
  const isDesktop = window.innerWidth >= 1024; // You can adjust this based on your specific breakpoint

  if (isDesktop) {
    // Prevent the popup from closing if clicked outside on desktop
    document.addEventListener('click', function (event) {
      const clickedInsidePopup = event.target.closest("[js-hb-product-info]");

      if (!clickedInsidePopup) {
        // Do nothing if clicked outside on desktop
        return;
      }
    });
  }

  // Close the popup if the back button inside the popup is clicked
  productInfo.forEach(info => {
    const popupBack = info.querySelector('[js-hb-popup-back]');

    if (popupBack) {
      popupBack.addEventListener('click', function () {
        info.classList.remove('popup_body_show');
        currentOpenPopup = null; // Reset the open popup tracker
      });
    }
  });
}


